<template>
  <v-card>
    <v-card-title class="px-8 pt-6">
      {{ $t('media.media_editor_title') }}
    </v-card-title>

    <v-card-text class="ma-0 pa-0">
      <div class="editor-container d-flex justify-center align-center">
        <PhotoEditor
          v-if="imagePath"
          :imagePath="imagePath"
          :showExportButton="false"
        />

        <v-progress-circular
          v-if="isLoading"
          indeterminate
          color="primary"
          size="52"
        />

        <h3 v-if="hasError">
          {{ $t('media.editor_load_error') }}
        </h3>
      </div>
    </v-card-text>

    <v-divider class="ma-0" />

    <v-card-actions class="justify-end ma-0 px-8 py-6">
      <DiscardChangesConfirmation
        :open="isDiscardConfirmationOpen"
        :saveButtonText="$t('media.discard_changes_save_and_back_button')"
        @cancel="isDiscardConfirmationOpen = false"
        @discard="handleDiscardChanges"
        @save="handleConfirmSave"
      />

      <Button
        class="me-2"
        plain
        :disabled="isSaving || isLoading"
        :text="$t('common.button.back')"
        @click="handleBack"
      />

      <Button
        color="primary"
        :disabled="isLoading"
        :loading="isSaving"
        :text="$t('common.button.save')"
        @click="handleSave"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'
import { IMAGE_SIZES } from 'rever-media-sdk'

import MediaSDK from '@/lib/ReverMediaSDK'

import PhotoEditor from '@/components/utils/MediaManagementWrapper/PhotoEditor/PhotoEditor.vue'
import DiscardChangesConfirmation from './DiscardChangesConfirmation.vue'
import Button from '@/components/UI/Button'

export default {
  name: 'MediaManagerEditor',

  components: {
    PhotoEditor,
    DiscardChangesConfirmation,
    Button,
  },

  props: {
    image: [Object, String],
  },

  data() {
    return {
      hasError: false,
      imagePath: null,
      isSaving: false,
      isLoading: false,
      isDiscardConfirmationOpen: false,
    }
  },

  created() {
    this.getImagePath()
  },

  watch: {
    image() {
      this.getImagePath()
    },
  },

  methods: {
    async getImagePath() {
      if (_.isString(this.image)) {
        this.imagePath = this.image
        return
      }

      try {
        this.isLoading = true
        this.imagePath = await MediaSDK.getImageSrc(
          this.image,
          IMAGE_SIZES.WIDE
        )
      } catch (err) {
        this.hasError = true
      } finally {
        this.isLoading = false
      }
    },

    async handleSave() {
      this.isSaving = true

      const result = await this.$pesdk?.export?.()

      this.isSaving = false

      this.$emit('save', result)
    },

    handleBack() {
      if (this.hasError) return this.$emit('back')

      this.isDiscardConfirmationOpen = true
    },

    handleDiscardChanges() {
      this.isDiscardConfirmationOpen = false
      this.hasError = false
      this.$emit('back')
    },

    handleConfirmSave() {
      this.isDiscardConfirmationOpen = false
      this.handleSave()
    },
  },
}
</script>

<style lang="scss" scoped>
.editor-container {
  height: 65vh;
}
</style>
